export default function TerminosYCondiciones() {
  return null;
}